
import Echarts from "echarts";
import moment from "moment";
const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];

export default function (data, date) {
    data.forEach((item, i) => {
        data[i].total = new Array(moment(date).daysInMonth()).fill(1).reduce((a, b, index) => item[`m${index + 1}`] >= 1 ? a + 1 : a, 0);
        data[i].name = item.short || item.name || "";
    });

    return data
}

export const setKarte = ({
    name,
    dataY,
    id,
    dataX
}, isOnResize) => {
    var myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        title: {
            text: name,
            textStyle: {
                align: 'left',
                color: '#333',
                fontSize: 20,
            },
            top: '5%',
            left: 'left',
        },
        grid: {
            bottom: 80
        },
        legend: {
            top: '30',
            data: ['this year', 'last year']
        },
        color,
        xAxis: {
            splitLine: {
                lineStyle: {
                    show: true,
                }
            },
            "axisLabel": {
                textStyle: {
                    fontSize: 12,
                    color: '#000'
                },
                minInterval: 1,
                rotate: -30
            },
            data: dataX,

        },
        yAxis: {
            name: name == 'Occ%' ? '%' : '',
            type: 'value'
        },
        tooltip: {
            trigger: 'axis',
            // formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
        },
        toolbox: {
            id,
            right: 20,
            feature: {
                saveAsImage: {
                    type: 'png',//	设置图片格式 png或者'jpeg
                    name,
                    backgroundColor: '#FFF',
                    excludeComponents: ['toolbox'],
                    show: true,
                    title: '保存图片',
                }
            }
        },
        series: [{
            name: "this year",
            type: 'bar',
            barMaxWidth: 20,
            data: dataY[0],

        }, {
            name: "last year",
            type: 'bar',
            barMaxWidth: 20,
            data: dataY[1],
        }]
    };

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/fullRoom/compute.js